import { SystemFeature } from '@/modules/releaseNotes/domain/models/enums/SystemFeature'
import SituationalIcon from '@/shared/components/icons/situational-icon'
import AbsentPatientIcon from '@/ui/assets/AbsentPatientIcon'
import BathroomHangerIcon from '@/ui/assets/BathroomHangerIcon'
import BellNotificationIcon from '@/ui/assets/BellNotificationIcon'
import BodyInspectionIcon from '@/ui/assets/BodyInspectionIcon'
import CalendarPersonIcon from '@/ui/assets/CalendarPersonIcon'
import ChatMessageIcon from '@/ui/assets/ChatMessageIcon'
import CommentsNewIcon from '@/ui/assets/CommentsNewIcon'
import FolderImageIcon from '@/ui/assets/FolderImageIcon'
import FoodIcon from '@/ui/assets/FoodIcon'
import HealthPinIcon from '@/ui/assets/HealhPinIcon'
import InterferingBehaviorIcon from '@/ui/assets/InterferingBehaviorIcon'
import LiquidIcon from '@/ui/assets/LiquidIcon'
import MedicalRecord from '@/ui/assets/MedicalRecord'
import MyGroupsIcon from '@/ui/assets/MyGroupsIcon'
import NotebookIcon from '@/ui/assets/NotebookIcon'
import OccurrenceIcon from '@/ui/assets/OccurrenceIcon'
import PersonIcon from '@/ui/assets/PersonIcon'
import RemediesIcon from '@/ui/assets/RemediesIcon'
import SessionsIcon from '@/ui/assets/SessionsIcon'
import SettingsCogIcon from '@/ui/assets/SettingsCogIcon'
import SleepStarCircleIcon from '@/ui/assets/SleepStarCircleIcon'
import StarManagerIcon from '@/ui/assets/StarMangerIcon'
import TicketPaperIcon from '@/ui/assets/TicketPaperIcon'
import ToyIcon from '@/ui/assets/ToyIcon'

const DEFAULT_COLOR = '#2196F3'

const iconMap: Record<SystemFeature, JSX.Element> = {
  INTERFERING_BEHAVIOR: <InterferingBehaviorIcon color={DEFAULT_COLOR} />,
  GROUPS: <MyGroupsIcon color={DEFAULT_COLOR} />,
  SLEEP: <SleepStarCircleIcon color={DEFAULT_COLOR} />,
  NOTIFICATIONS: <BellNotificationIcon color={DEFAULT_COLOR} />,
  REMEDIES: <RemediesIcon color={DEFAULT_COLOR} />,
  PATIENTS: <PersonIcon color={DEFAULT_COLOR} />,
  AGENDA: <CalendarPersonIcon color={DEFAULT_COLOR} />,
  SESSION: <SessionsIcon color={DEFAULT_COLOR} />,
  LIQUID: <LiquidIcon color={DEFAULT_COLOR} />,
  CHAT: <ChatMessageIcon color={DEFAULT_COLOR} />,
  MEDICAL_RECORD: <MedicalRecord color={DEFAULT_COLOR} />,
  BATHROOM: <BathroomHangerIcon color={DEFAULT_COLOR} />,
  BELONGINGS: <ToyIcon color={DEFAULT_COLOR} />,
  BODY_EXAM: <BodyInspectionIcon color={DEFAULT_COLOR} />,
  PATIENT_CONFIG: <SituationalIcon color={DEFAULT_COLOR} />,
  TASKS: <NotebookIcon color={DEFAULT_COLOR} />,
  TICKETS: <TicketPaperIcon color={DEFAULT_COLOR} />,
  FOOD: <FoodIcon color={DEFAULT_COLOR} />,
  PATIENT_COMMENTS: <CommentsNewIcon color={DEFAULT_COLOR} />,
  DRIVE: <FolderImageIcon color={DEFAULT_COLOR} />,
  SESSION_MANAGEMENT: <SessionsIcon color={DEFAULT_COLOR} />,
  OCCURRENCES_MANAGEMENT: <OccurrenceIcon color={DEFAULT_COLOR} />,
  FREQUENCY_MANAGEMENT: <HealthPinIcon color={DEFAULT_COLOR} />,
  GENERAL: <SettingsCogIcon color={DEFAULT_COLOR} />,
  ABSENCE_MANAGEMENT: <AbsentPatientIcon color={DEFAULT_COLOR} />,
  NEW: <StarManagerIcon color={DEFAULT_COLOR} />,
  BELONGINGS_MANAGEMENT: <ToyIcon color={DEFAULT_COLOR} />,
  FOOD_MANAGEMENT: <FoodIcon color={DEFAULT_COLOR} />,
  REMEDIES_MANAGEMENT: <RemediesIcon color={DEFAULT_COLOR} />
}

export default function SystemFeatureIcon({
  systemFeature
}: {
  systemFeature: SystemFeature
}) {
  return iconMap[systemFeature]
}
